import React, { useState } from 'react';
import { Box, Chip, CircularProgress, Collapse, Link } from '@mui/material';

const prettyName = (name) => (name || '').replace(/_/g, ' ');

/*
 * The "what is it doing right now" line.
 *
 * A tool-heavy answer takes 30-60 seconds. Naming the tool that is running is
 * the difference between a wait that reads as work and one that reads as a
 * hang — so the running chip is always visible, and finished ones collapse
 * behind a count once there are more than three.
 */
const ToolChips = ({ calls }) => {
  const [expanded, setExpanded] = useState(false);
  if (!calls || !calls.length) return null;

  const running = calls.filter((call) => call.status === 'running');
  const finished = calls.filter((call) => call.status !== 'running');
  const collapse = !expanded && finished.length > 3;
  const shown = collapse ? [] : finished;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, alignItems: 'center', mb: 1 }}>
      {running.map((call) => (
        <Chip
          key={`running-${call.name}`}
          size="small"
          icon={<CircularProgress size={12} thickness={6} sx={{ ml: 1 }} />}
          label={prettyName(call.name)}
          sx={{ fontSize: 12 }}
        />
      ))}

      {collapse ? (
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={() => setExpanded(true)}
          sx={{ fontSize: 12.5, color: 'text.secondary' }}
        >
          {`${finished.length} tools used`}
        </Link>
      ) : null}

      <Collapse in={!collapse} orientation="horizontal" sx={{ display: 'contents' }}>
        {shown.map((call, index) => (
          <Chip
            key={`${call.name}-${index}`}
            size="small"
            variant="outlined"
            color={call.status === 'error' ? 'error' : 'default'}
            label={
              call.ms ? `${prettyName(call.name)} · ${(call.ms / 1000).toFixed(1)}s` : prettyName(call.name)
            }
            sx={{ fontSize: 12 }}
          />
        ))}
      </Collapse>
    </Box>
  );
};

export default ToolChips;
